import { gql } from '@apollo/client';

const schema = {
  get: {
    name: "userCategory",
    serviceName: "unitadmin",
    query: gql`
      query userCategory($ids: [String]) {
        userCategory(ids: $ids) {
          data {
            title
          }
        }
      }
    `,
  },
  update: {
    name: "updateUserCategory",
    serviceName: "unitadmin",
    query: gql`
      mutation updateUserCategory($ids: [String]!, $title: String!) {
        updateUserCategory(ids: $ids, title: $title) {
          messages
        }
      }
    `,
  },
};

export default schema;
